import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Accordion,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { DatePickerField } from 'Common/SemanticWrapper';
import { TitledCard, DatePickerCustomButton } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { GenericFiltersContainer } from 'Components/filters/container';
import { ItemListingReportEnum } from 'Common/FieldEnum';
import { ITEM_LISTING_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { SortOptionEnum } from 'Common/Constants/Enumeration/ItemListingReportEnum';

import { ItemList } from './../containers/ItemListContainer';
import { sortOptions } from './../helper/index';

import 'Styles/pages/reports/inventory/itemlistingreport.less';

const ItemListingReportComponent = props => {
  const {
    fields,
    handleChange,
    filterValues,
    clearFilters,
    sortOptionsValue,
    itemListingReportData,
    setSortByOption,
    onChangeOfDT,
    activeIndexForFilter,
    handleClick,
    onSortedChange,
    onFilteredChange,
    sorted,
    filtered,
    reactTableRef,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Row columns={3}>
                <Grid.Column width={8} verticalAlign={'bottom'}>
                  <TitledCard title={'Sort By'}>
                    <ReduxFormButtonGroup
                      options={sortOptions}
                      value={sortOptionsValue}
                      formName={ITEM_LISTING_FORM_NAME}
                      fieldName={ItemListingReportEnum.SortOptions}
                      type={'button'}
                      onChange={setSortByOption}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    component={DatePickerField}
                    label={'BID PRICE DATE'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={ItemListingReportEnum.BidPriceDate}
                    onChange={onChangeOfDT}
                    type={'text'}
                    customInput={<DatePickerCustomButton />}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column
                  width={4}
                  textAlign={'right'}
                  style={{ marginTop: 45 }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <Field
                component={ItemList}
                name={ItemListingReportEnum.ItemListInfo}
                {...{
                  itemListingReportData,
                  onSortedChange,
                  onFilteredChange,
                  sorted,
                  filtered,
                  reactTableRef,
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

ItemListingReportComponent.propTypes = {
  fields: PropTypes.array.isRequired,
  filterValues: PropTypes.object.isRequired,
  itemListingReportData: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  setSortByOption: PropTypes.func,
  onChangeOfDT: PropTypes.func,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  handleClick: PropTypes.func,
  sortOptionsValue: PropTypes.number,
  activeIndexForFilter: PropTypes.number,
  sorted: PropTypes.array,
  filtered: PropTypes.array,
  reactTableRef: PropTypes.object,
};

ItemListingReportComponent.defaultProps = {
  handleChange: () => {},
  clearFilters: () => {},
  setSortByOption: () => {},
  onChangeOfDT: () => {},
  onSortedChange: () => {},
  onFilteredChange: () => {},
  sortOptionsValue: SortOptionEnum.ItemCode,
  activeIndexForFilter: 0,
  sorted: [],
  filtered: [],
  reactTableRef: null,
};

export default ItemListingReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/components/ItemListingReport.js